import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import SubTab from './../SubTab/SubTab';

const HongseongYouthGrowth = () => {
  const category = 'HongseongYouthGrowth';
  const [dotCount, setDotCount] = useState(0);
  const [select, setSelect] = useState(0);
  const navigate = useNavigate();
  const handleSelect = (num) => {
    if (select === num) {
      setSelect(0);
    } else {
      setSelect(num);
    }
  };

  // 점 애니메이션 (... 깜빡이는 효과)
  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev + 1) % 4);
    }, 500);
    return () => clearInterval(interval);
  }, []);

  const movePage = (path) => {
    navigate(path);
  };

  const containerStyle = {
    width: '100%',
    height: '60vh', // 🔹 세로 크기 줄임
    background: '#f8f8f8',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    fontFamily: "'Pretendard', 'Noto Sans KR', sans-serif",
    color: '#202632',
    textAlign: 'center',
  };

  const logoStyle = {
    fontSize: '26px',
    fontWeight: '700',
    color: '#00a45a', // 🔹 포인트 녹색
    letterSpacing: '1px',
    marginBottom: '10px',
  };

  const titleStyle = {
    fontSize: '28px',
    fontWeight: '700',
    marginBottom: '10px',
  };

  const subStyle = {
    fontSize: '16px',
    color: '#555',
    marginBottom: '15px',
  };

  const dotWrapperStyle = {
    height: '30px', // 🔹 높이 고정 → 점 위치 고정
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    color: '#00a45a',
    fontWeight: '700',
    letterSpacing: '3px',
  };

  return (
    <div className="sub_wrap">
      <div className="sub_back">
        <div className="sub_banner_area">
          <div className="sub_banner_back">
            <div className="navi_text">
              <div className="home_icon_sub"></div>
              {'> '}사업분야{' > '}창업 육성 사업
            </div>
            <div className="banner_main_text">창업 육성 사업</div>
          </div>
        </div>
        <div className="navi_area">
          <div className="navi_back">
            <div className="navi_box business_field" onClick={() => handleSelect(1)}>
              <div className="navi_main_text">창업육성사업</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 1 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/fusionSupportProgram')}>
                  산학융합지구조성사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/chungnamInnovationProject')}>
                  기업지원사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/localIndustryTalentDevelopment')}>
                  인재양성사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/YouthEmploymentSupport')}>
                  창업육성사업
                </div>
              </div>
            </div>
            <div className="navi_box founded" onClick={() => handleSelect(2)}>
              <div className="navi_main_text">홍성군 청년성장 프로젝트</div>
              <div className="navi_arrow"></div>
              <div className={`navi_select_box ${select === 2 && 'active'}`}>
                <div className="select_row" onClick={() => movePage('/business/youthVentureProgram')}>
                  당진시 청년도전지원사업
                </div>
                <div className="select_row" onClick={() => movePage('/business/MiddleAgedStartupCenter')}>
                  당진시 중장년기술창업센터
                </div>
                <div className="select_row" onClick={() => movePage('/business/YouthEmploymentSupport')}>
                  당진시 청년 취·창업 지원사업
                </div>
                {/* <div className="select_row" onClick={() => movePage('/business/DangjinYouthChallenge')}>
                  당진시 청년도전지원사업
                </div> */}
                <div className="select_row" onClick={() => movePage('/business/YouthGrowthProject')}>
                  당진시 청년성장 프로젝트
                </div>
                <div className="select_row" onClick={() => movePage('/business/HongseongYouthGrowth')}>
                  홍성군 청년성장 프로젝트
                </div>
                {/* <div className="select_row" onClick={() => movePage('/business/HongseongCultureStartup')}>
                  홍성군 복합문화창업공간 잇슈창고
                </div> */}
                <div className="select_row" onClick={() => movePage('/business/HongseongJobAdaptation')}>
                  홍성군 직장적응 지원사업
                </div>
                {/* <div className="select_row" onClick={() => movePage('/business/hopeReturnPackage')}>
                  희망리턴패키지 사업
                </div> */}
                <div className="select_row" onClick={() => movePage('/business/hongseongIssueWarehouse')}>
                  홍성군 잇슈창고운영사업
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="sub_main_area temporary">
          <SubTab category={category} />
          {/* 🔹 공통으로 돌려 쓸 카드 헤더(리디자인 영역) */}
          <div className="business-hero">
            <div className="business-hero-inner">
              <p className="business-hero-tag">Hongseong Youth Growth Project</p>
              <h2 className="business-hero-title">홍성군 청년성장 프로젝트</h2>
              <p className="business-hero-period">사업기간 : (신규사업) 2025.3.~ 2026.12.31.</p>
              <p className="business-hero-period">담당부처: 고용노동부</p>
            </div>
          </div>
          <div className="sub_main_back">
            {/* 수정필요 dangjin-img1 > middle-img1*/}
            <div className="dangjin-img1"></div>
            <div className="vision_container">
              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">추진체계 및 목표</div>
              </div>
              <div className="business_img_box">
                <div className="hongseong-youth-growth-img1"></div>
              </div>
              <div className="vision_title_box nonline">
                <div className="logo_box">
                  <div className="logo_img"></div>
                </div>
                <div className="title_text">사업내용</div>
              </div>
              <div className="local_final_result_box">
                <div className="project-result-box table-container ">
                  <table className="project-result-table">
                    <thead>
                      <tr>
                        <th colSpan={2} style={{ width: '40%' }}>
                          구분
                        </th>
                        <th>지원내용</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td rowSpan={2}>인프라 제공</td>
                        <td>홍성잇슈창고 공간 제공</td>
                        <td>홍성잇슈창고 공간 운영</td>
                      </tr>
                      <tr>
                        <td>혜전대학교 공유공간 제공</td>
                        <td>혜전대학교 공유공간 안내 및 제공</td>
                      </tr>
                      <tr>
                        <td rowSpan={3}>프로그램 제공</td>
                        <td>초기상담</td>
                        <td>초기상담을 통해 청년 정책사업 안내, 프로그램 참여 및 연계프로그램 연결</td>
                      </tr>
                      <tr>
                        <td>맞춤형 프로그램</td>
                        <td>참여자별 맞춤형 프로그램으로 쉼청년 방지 교육 제공</td>
                      </tr>
                      <tr>
                        <td>(특강)부모교육 지원</td>
                        <td>청년부모를 대상으로 청년 정책 사업 안내 및 청년에 대한 이해의 폭 넓히기 위한 기회 마련</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HongseongYouthGrowth;
